import moment from "moment";
import ReactDatePicker from "react-datepicker"

interface IYearCalendarProps {
  startDate: Date | null | undefined;
  endDate: Date | null | undefined;
  onChange: (date: [Date | null, Date | null]) => void;
}

const YearContent = (year: number) => {
  return <div className="px-2 py-2">{year}</div>;
};

export const YearCalendar = ({ startDate, endDate, onChange}: IYearCalendarProps) => {
  return (
    <ReactDatePicker
      selected={startDate}
      onChange={(date) => {
        const start = moment(date).toDate();
        const end = moment(date).endOf('year').toDate();
        onChange([start, end])
      }}
      calendarStartDay={1}
      startDate={startDate}
      endDate={endDate}
      calendarClassName="!border-0"
      inline
      disabledKeyboardNavigation
      showYearPicker={true}
      renderYearContent={YearContent}
    />
  )
}